export default "__VITE_ASSET__nTs9ShAM__"